import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button } from '@/components/button'
import { Modal } from '@/components/modalize/mui/modal'

const Container = styled.div`
  position: relative;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
`

const BaseDialog = ({
  okLabel,
  cancelLabel,
  show,
  proceed,
  dismiss,
  cancel,
  children,
  isDisabled,
  isWarning,
  hideCancelButton,
  buttonContainerStyle,
  okButtonProps,
  cancelButtonProps,
  ...rest
}) => {
  const { t } = useTranslation()
  if (!show) return null
  return (
    <div aria-modal>
      <Modal {...rest} isOpen={show} onClose={dismiss}>
        <Container>
          {children}
          <ButtonContainer style={{ ...buttonContainerStyle }}>
            {!hideCancelButton && (
              <Button theme="secondary" onClick={cancel} {...cancelButtonProps}>
                {cancelLabel || t('common.no', 'No')}
              </Button>
            )}
            <Button
              id="yes_confirm"
              theme={isWarning ? 'primary' : 'delete'}
              onClick={proceed}
              disabled={isDisabled()}
              {...okButtonProps}
            >
              {okLabel || t('common.yes', 'Yes')}
            </Button>
          </ButtonContainer>
        </Container>
      </Modal>
    </div>
  )
}

BaseDialog.defaultProps = {
  proceed: undefined,
  cancel: undefined,
  dismiss: undefined
}

export default BaseDialog
